export const selectFormStatusByIdentifier = (state, identifier) => {
    if(!identifier) {
        return ''
    }
    return state?.form?.[identifier]?.status
}

